import CampoCheckbox from "@/components/Formulario/CampoCheckbox";
import CampoMultiTexto from "@/components/Formulario/CampoMultiTexto";
import CampoSeletor from "@/components/Formulario/CampoSeletor";
import CampoSenha from "@/components/Formulario/CampoSenha";
import CampoTexto from "@/components/Formulario/CampoTexto";
import Grid, { GridItem } from "@/components/layout/Grid";

export const FormDynamicParams: React.FC<{
    schema: any[];
    values: Record<string, any>;
    onChange: (values: Record<string, any>) => void;
    errors?: Record<string, string>;
}> = ({ schema, values, onChange, errors }) => {
    return (
        <Grid>
            {schema.map((field) => (
                <GridItem key={field.name} sm={12} md={6}>
                    {field.type === "boolean" ? (
                        <CampoCheckbox
                            label={field.title}
                            value={values[field.name] || false}
                            onChange={(checked) =>
                                onChange({ ...values, [field.name]: checked })
                            }
                            error={errors?.[field.name]}
                            autoComplete="off"
                        />
                    ) : field.type === "number" ? (
                        <CampoTexto
                            label={field.title}
                            value={values[field.name]?.toString() || ""}
                            onChange={(v) => onChange({ ...values, [field.name]: Number(v) })}
                            type="number"
                            required={field.required}
                            error={errors?.[field.name]}
                            autoComplete="off"
                        />
                    ) : field.type === "list" && field.options ? (
                        <CampoSeletor
                            label={field.title}
                            options={field.options}
                            value={values[field.name] || ""}
                            onChange={(v) => onChange({ ...values, [field.name]: v })}
                            required={field.required}
                            error={errors?.[field.name]}
                            autoComplete="off"
                        />
                    ) : field.type === "string[]" ? (
                        <CampoMultiTexto
                            label={field.title}
                            options={field.options}
                            value={values[field.name] || ""}
                            onChange={(v) => onChange({ ...values, [field.name]: v })}
                            required={field.required}
                            error={errors?.[field.name]}
                            autoComplete="off"
                        />
                    ) : field.sensitive ?
                        (
                            <CampoSenha
                                label={field.title}
                                value={values[field.name] || ""}
                                onChange={(v) => onChange({ ...values, [field.name]: v })}
                                required={field.required}
                                error={errors?.[field.name]}
                                autoComplete="off"
                            />
                        ) : (
                            <CampoTexto
                                label={field.title}
                                value={values[field.name] || ""}
                                onChange={(v) => onChange({ ...values, [field.name]: v })}
                                required={field.required}
                                error={errors?.[field.name]}
                                autoComplete="off"
                            />
                        )}
                </GridItem>
            ))}
        </Grid>
    );
};